import { Layout } from "antd"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router"
import { Link } from "react-router-dom"
import pageService from "~/modules/page/services/page"
import { PageData, PageResponse, PostData, PostResponse, UserAttributes } from "~/types/types"
import { t } from "../../languages/i18n"
import { fetchPosts } from "../post/services/post"
import userService from "../users/services/userService"
import Card3 from "./Card3"
import Card4 from "./Card4"
import Card5 from "./Card5"

const { Content } = Layout

const Dashboard: React.FC = () => {
  const [loadingPost, setLoadingPost] = useState(false)
  const [loadingPage, setLoadingPage] = useState(false)
  const [loadingUser, setLoadingUser] = useState(false)
  const [latestPages, setLatestPages] = useState<PageData[]>([])
  const [latestPosts, setLatestPosts] = useState<PostData[]>([])
  const [latestUsers, setLatestUsers] = useState<UserAttributes[]>([])

  const [pageCount, setPageCount] = useState(0)
  const [postCount, setPostCount] = useState(0)
  const [userCount, setUserCount] = useState(0)
  const [commentCount, setCommentCount] = useState(0)
  const navigate = useNavigate()
  const userServices = userService()

  const handleLearnMore = () => {
    navigate("/pages", { state: { showLatest: true } })
  }
  const handleSeeDetail = () => {
    navigate("/posts", { state: { showLatest: true } })
  }
  const handleLSeeMore = () => {
    navigate("/users", { state: { showLatest: true } })
  }

  const { fetchAllPages } = pageService()

  const fetchPagesData = async (): Promise<PageResponse> => {
    const response = await fetchAllPages()
    return response as PageResponse
  }

  const fetchPostData = async (): Promise<PostResponse> => {
    const response = await fetchPosts()
    return response as PostResponse
  }

  const fetchUsers = async (searchTerm?: { [key: string]: string }) => {
    try {
      const response = await userServices.fetchAllUsers(searchTerm)
      setLatestUsers(response?.data)
      setUserCount(response?.data.length)
    } catch (error) {
      console.error("Error fetching users:", error)
    }
  }

  const checkPermission = (key: string) => {
    const permissions = JSON.parse(localStorage.getItem("permissions") || "[]")
    if (permissions[key]?.find?.enabled === true) return true
    else return false
  }

  useEffect(() => {
    setLoadingUser(true)
    setLoadingPost(true)
    setLoadingPage(true)

    const fetchData = async () => {
      if (checkPermission("page")) {
        try {
          const response = await fetchPagesData()
          if (response?.error) {
          } else {
            setPageCount(response.data.length)
            setLatestPages(response.data)
          }
        } catch (error) {
          console.error("Error fetching data:", error)
        }
      }

      if (checkPermission("post")) {
        try {
          const response = await fetchPostData()

          if (response?.error) {
          } else {
            setPostCount(response.data.length)
            setLatestPosts(response.data)
          }
        } catch (error) {
          console.error("Error fetching data:", error)
        }
      }
    }

    if (checkPermission("user")) {
      fetchUsers()
    }

    fetchData()

    setLoadingUser(false)
    setLoadingPage(false)
    setLoadingPost(false)
  }, [])

  return (
    <div className="m-4">
      <div className="text-left mb-6">
        <h1 className="text-3xl font-semibold">{t("Dashboard")}</h1>
      </div>
      <Content>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-2">
          {JSON.parse(localStorage.getItem("permissions") || "[]").page.find.enabled === true && (
            <div className=" flex flex-col items-normal justify-start p-2 w-full transition-all duration-300 min-h-[300px] h-auto hover:scale-105">
              <Link to="/pages">
                <Card3
                  setLoading={setLoadingPage}
                  loading={loadingPage}
                  key={3}
                  latestPages={latestPages}
                  handleLearnMore={handleLearnMore}
                  setDraggedCardId={() => {}}
                />
              </Link>
            </div>
          )}

          {JSON.parse(localStorage.getItem("permissions") || "[]").post.find.enabled === true && (
            <div className=" flex flex-col items-normal justify-start p-2 w-full transition-all duration-300 min-h-[300px] h-auto hover:scale-105">
              <Link to="/posts">
                <Card4
                  setLoading={setLoadingPost}
                  loading={loadingPost}
                  key={4}
                  latestPosts={latestPosts}
                  handleSeeDetail={handleSeeDetail}
                  setDraggedCardId={() => {}}
                />
              </Link>
            </div>
          )}

          {JSON.parse(localStorage.getItem("permissions") || "[]").user.find.enabled === true && (
            <div className=" flex flex-col items-normal justify-start p-2 w-full transition-all duration-300 min-h-[300px] h-auto hover:scale-105">
              <Link to="/users">
                <Card5
                  setLoading={setLoadingUser}
                  loading={loadingUser}
                  key={5}
                  latestUsers={Array.isArray(latestUsers) ? latestUsers : []}
                  handleLSeeMore={handleLSeeMore}
                  setDraggedCardId={() => {}}
                />
              </Link>
            </div>
          )}
        </div>
      </Content>
    </div>
  )
}

export default Dashboard
